import { useQuery } from "@tanstack/react-query"
import { useParams } from "react-router"

import { getReport } from "@/features/datapoints/api/report/getReport.ts"
import DataPointReportBuilder from "@/features/datapoints/components/report/DataPointReportBuilder.tsx"

export default function EditRepor() {
  const params = useParams()
  const id = Number(params.id)
  const { data, isPending, isError } = useQuery({
    queryKey: ["dataPointReport", { id }],
    queryFn: () => getReport(id),
  })
  if (isPending) return <>Loading</>
  if (isError) return <>Error</>

  return <DataPointReportBuilder report={data} />
}
